import * as actionTypes from './../types/menuTypes'

const INITIAL_STATE = {
    loading: false,
    menu: [],
    error: ''
}

const menuReducer = (state = INITIAL_STATE, action) => {

    switch (action.type) {

        case actionTypes.FETCH_MENU_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            }

        case actionTypes.FETCH_MENU_SUCCESS:
            return {
                loading: false,
                menu: action.payload,
                error: ''
            }

        case actionTypes.FETCH_MENU_FAILURE:
            return {
                loading: false,
                menu: [],
                error: action.payload
            }

        default:
            return state
    }
}

export default menuReducer